// src/pages/DeleteRequests.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebase.utils';
import LogoSection from '../components/LogoSection';

const DeleteRequests = () => {
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.userRole);
    const [deleteRequests, setDeleteRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Only show if user is admin
        if (userRole !== 'admin') {
            return;
        }

        const unsubscribe = onSnapshot(
            query(collection(db, 'delete-requests'), orderBy('timestamp', 'desc')),
            (snapshot) => {
                const requests = [];
                snapshot.forEach((doc) => {
                    const data = doc.data();
                    requests.push({
                        id: doc.id,
                        email: data.email,
                        timestamp: data.timestamp?.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
                    });
                });
                setDeleteRequests(requests);
                setLoading(false);
            },
            (error) => {
                console.error('Error fetching delete requests:', error);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [userRole]);

    const formatDate = (timestamp) => {
        if (!timestamp) return 'No date';
        return timestamp.toLocaleString();
    };

    if (userRole !== 'admin') {
        return (
            <div className="min-h-screen flex justify-center">
                <div className="w-full max-w-screen-lg flex flex-col items-center space-y-3 px-4 md:px-16">
                    <LogoSection />
                    <div className="text-center">
                        <h1 className="text-2xl text-red-600">Access Denied</h1>
                        <p className="text-gray-600 mt-2">You must be an admin to view this page.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex justify-center">
            <div className="w-full max-w-screen-lg flex flex-col items-center space-y-3 px-4 md:px-16">
                <LogoSection />

                <div className="w-full">
                    <h1 className="text-3xl mb-4 text-center">Account Deletion Requests</h1>

                    {loading ? (
                        <div className="text-center text-gray-500">Loading...</div>
                    ) : deleteRequests.length === 0 ? (
                        <div className="text-center text-gray-500">No deletion requests found.</div>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="min-w-full bg-white border border-gray-200">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="py-3 px-4 border-b text-left">Email</th>
                                        <th className="py-3 px-4 border-b text-left">Request Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {deleteRequests.map((request) => (
                                        <tr key={request.id} className="hover:bg-gray-50">
                                            <td className="py-3 px-4 border-b">{request.email}</td>
                                            <td className="py-3 px-4 border-b">{formatDate(request.timestamp)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeleteRequests;

